export class MobileMenu {
    constructor(public bodyElement: any) {
        let mobileTrigger = document.getElementById('mobileTrigger');
        let mobileMenu = document.getElementById('headerNav');
        let mobileSubnavTriggers = [].slice.call(document.getElementsByClassName('mnav-list-mobiletrigger-js'));
        let searchContainer = document.getElementById('siteSearch');

        let switchToContext = mobileMenu.getElementsByClassName('js-memberContext'),
            switchFromContext = mobileMenu.querySelector('#activeCategory'),
            currentContext = switchFromContext.getElementsByTagName('h5')[0].innerHTML,
            switchFromContextLS = localStorage.getItem('switchFromContext'),
            switchToContextLS = localStorage.getItem('switchToContext');
     
        if (switchToContextLS != null && switchFromContextLS != switchToContextLS) {
          mobileMenu.classList.toggle('open');
          mobileTrigger.classList.toggle('open');
          searchContainer.classList.remove('active');
          this.bodyElement.classList.toggle('nav-open');
        }

        //On Page Load remove the nav-open class if mobile nav is not active
        window.addEventListener("load", (e) => {
            if (mobileTrigger != undefined && !mobileTrigger.classList.contains("open")) {
                document.querySelector('body').classList.remove('nav-open');
            }
        });

        if (mobileTrigger) {
          localStorage.setItem('switchFromContext', currentContext);

            for (let i = 0; i < switchToContext.length; i++) {
              switchToContext[i].addEventListener("click", function (e)
              {
                  localStorage.setItem('switchToContext', (switchToContext[i].getElementsByTagName('h5')[0].innerHTML));
              })
          }

            mobileTrigger.addEventListener('click', (e) => {
                e.preventDefault();
                mobileMenu.classList.toggle('open');
                mobileTrigger.classList.toggle('open');
                searchContainer.classList.remove('active');
                this.bodyElement.classList.toggle('nav-open');
            });

            mobileSubnavTriggers.forEach((mobileSubnavTrigger) => {
                mobileSubnavTrigger.addEventListener('click', function (e) {
                    e.preventDefault();
                    var subnavID = this.getAttribute('data-trigger-id');
                    var subnavToOpen = document.querySelector('[data-id="' + subnavID + '"]');

                    this.classList.toggle('open');
                    subnavToOpen.classList.toggle('open');

                    if (subnavToOpen.classList.contains('open')) {
                        subnavToOpen.setAttribute('aria-hidden', 'false');
                    } else {
                        subnavToOpen.setAttribute('aria-hidden', 'true');
                    }
                });
            });


        }
    }
}


// WEBPACK FOOTER //
// ./Static/javascript/modules/mobile-menu.ts